var map = {
	"./ECTEL21.PNG": 6913,
	"./ECTEL21_.PNG": 4719,
	"./EDM21.png": 1196,
	"./EDM21——.png": 4060,
	"./ICLS22.PNG": 6633,
	"./ICLS22_.PNG": 9630,
	"./NAO.PNG": 2829,
	"./Pair-UpInterface.png": 761,
	"./PairUpEcoSystem.png": 2776,
	"./PairUpEcoSystem_.png": 7350,
	"./aptaOld.png": 2092,
	"./b5.webp": 3696,
	"./cscw21.png": 2850,
	"./cscw21_.png": 8261,
	"./elk.png": 1943,
	"./elk_.png": 1455,
	"./logit.webp": 6509,
	"./lynnette.png": 5918,
	"./new-fig-2.png": 2440,
	"./new-fig-3.png": 624,
	"./new-fig-5.png": 4553,
	"./new-fig-6.png": 2415,
	"./rstAnnotated.png": 6058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9166;